import { render } from "./LocalStatsItem.vue?vue&type=template&id=2edb319a&scoped=true&ts=true"
import script from "./LocalStatsItem.vue?vue&type=script&lang=ts"
export * from "./LocalStatsItem.vue?vue&type=script&lang=ts"

import "./LocalStatsItem.vue?vue&type=style&index=0&id=2edb319a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edb319a"]])

export default __exports__